const NS = 'EditTableCtrl';

export default function EditTableCtrl(
  $log, $stateParams, tablesService
) {
  "ngInject";

  const vm = this;

  getTable();

  function getTable() {
    var id = $stateParams.id;
    tablesService.getTableById(id).then(function (table) {
      vm.table = table;
    }).catch(function (err) {
      $log.error('failed to load table', err);
    });
  }
}
